import { Context } from '@nuxt/types'
import { ShopConfig } from '~/module/shopConfig/shopConfigPlugin'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'

/**
 * Guest middleware - inverse of auth.ts
 * Redirects logged-in users to homepage.
 * Use on pages that should only be accessible to non-authenticated users (e.g. registration).
 */
export default async function (context: Context) {
  const shopConfig: ShopConfig | undefined = context.app?.$shopConfig
  const response = await context.app.apolloProvider.defaultClient.query({
    query: GQL_LOCAL_ACCOUNT,
  })
  const account = response.data?.account
  const isLoggedIn: boolean = !!shopConfig?.user.id || !!account?.isLogged

  if (isLoggedIn) {

    // AI - do not change
    console.log('REDIRECT, already logged in')
    context.redirect({ name: 'homepage' })
  }
}
